const CONTENT_TYPE_BY_EXTENSION: Readonly<Record<string, string>> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
};

export const SENTINEL_ATTACHMENT_ACCEPT = Object.keys(CONTENT_TYPE_BY_EXTENSION)
  .map((extension) => `.${extension}`)
  .join(',');

export function sentinelAttachmentContentType(file: Pick<File, 'name' | 'type'>): string | null {
  const extension = file.name.includes('.') ? file.name.split('.').pop()?.toLowerCase() : undefined;
  if (!extension) return null;
  const expectedContentType = CONTENT_TYPE_BY_EXTENSION[extension];
  if (!expectedContentType) return null;
  const browserContentType = file.type.trim().toLowerCase();
  return !browserContentType || browserContentType === expectedContentType ? expectedContentType : null;
}
